import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "67",
  height: "78",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#BEC2C9",
      "stroke-width": "4",
      d: "m23.7 65.443-.586-.586H7.43c-3 0-5.429-2.429-5.429-5.428v-52C2 4.429 4.429 2 7.429 2h52c3 0 5.428 2.429 5.428 5.429v52c0 3-2.429 5.428-5.428 5.428H43.743l-.586.586-9.728 9.729z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#BEC2C9",
      d: "M33.337 12C26.534 12 21 17.534 21 24.337a2.868 2.868 0 0 0 5.735 0 6.61 6.61 0 0 1 6.602-6.602 6.61 6.61 0 0 1 6.6 6.602 6.61 6.61 0 0 1-6.6 6.6 2.87 2.87 0 0 0-2.868 2.868v6.484a2.868 2.868 0 0 0 5.735 0v-3.952c5.424-1.296 9.47-6.185 9.47-12C45.673 17.533 40.138 12 33.336 12M33.337 54.05a4.015 4.015 0 1 0 0-8.029 4.015 4.015 0 0 0 0 8.03"
    }, null, -1)
  ]))]))
}
export default { render: render }